module.exports = __webpack_public_path__ + "img/tp-6.4c1fe757.png";